export const FESTIVAL_LINK = "https://link.amazon/B0eQnGl8p";
export const HOME_KITCHEN_LINK = "https://link.amazon/B0j90V6qe";
export const GOURMET_LINK = "https://link.amazon/B03g3BvpY";
export const TOYS_LINK = "https://link.amazon/B05IOVQNF";
export const ONEPLUS_PAD_LINK = "https://link.amazon/B08Ja0mK1";
export const SAFARI_LUGGAGE_LINK = "https://link.amazon/B0e2yArIc";
export const BOAT_SPEAKER_LINK = "https://link.amazon/B09r15R8k";
export const MIC_LINK = "https://link.amazon/B0gkEFts9";
export const LG_WM_LINK = "https://link.amazon/B03rww14U";
export const KIDS_JUMPSUIT_LINK = "https://link.amazon/B06jctuJ5";
export const BEAUTY_GHAR_LINK = "https://link.amazon/B01NfIp0k";
export const KURTA_LINK = "https://link.amazon/B04493y1P";
export const EARRINGS_LINK = "https://link.amazon/B01kbHs8t";
export const BRACELET_LINK = "https://link.amazon/B03ZbSxjU";
export const COOKER_LINK = "https://link.amazon/B01VUGRZL";
export const INVICTA_LINK = "https://link.amazon/B04pmb1zd";
export const SWADDLE_LINK = "https://link.amazon/B05N4KTQz";
export const TEMPLE_LINK = "https://link.amazon/B09DmBB2I";
export const NECKLACE_LINK = "https://link.amazon/B09LLTdq2";
export const HOMEPAGE_LINK = "https://link.amazon/B01AGRfuc";
export const STOREFRONT_URL = HOMEPAGE_LINK;

export const CATEGORIES = [
  { key: "all", label: "All Finds", testid: "category-filter-all" },
  { key: "Electronics & Gadgets", label: "Electronics", testid: "category-filter-electronics" },
  { key: "Home & Kitchen", label: "Home & Kitchen", testid: "category-filter-home" },
  { key: "Fashion & Accessories", label: "Fashion", testid: "category-filter-fashion" },
  { key: "Toys & Games", label: "Toys & Games", testid: "category-filter-toys" },
  { key: "Beauty & Personal Care", label: "Beauty", testid: "category-filter-beauty" },
  { key: "Baby Care", label: "Baby Care", testid: "category-filter-baby" },
];

export const PRODUCTS = [
  {
    id: "prod-1",
    title: "Minimalist Wireless Studio Headphones",
    category: "Electronics & Gadgets",
    price: "$299.99",
    rating: 4.9,
    reviews: 1420,
    badge: "Editor's Choice",
    image: "https://images.unsplash.com/photo-1498049794561-7780e7231661?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwZWxlY3Ryb25pY3MlMjBnYWRnZXRzJTIwdGVjaHxlbnwwfHx8fDE3OTA0MTk5NjN8MA&ixlib=rb-4.1.0&q=85",
    link: FESTIVAL_LINK,
    description: "High-fidelity active noise canceling studio monitor headphones engineered with matte obsidian aluminum.",
  },
  {
    id: "prod-2",
    title: "Precision Moka Espresso Maker",
    category: "Home & Kitchen",
    price: "$54.50",
    rating: 4.8,
    reviews: 890,
    badge: "Best Seller",
    image: "https://images.unsplash.com/photo-1593369196682-6d8ec9ff3ae0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjE2NzN8MHwxfHNlYXJjaHwxfHxlc3ByZXNzbyUyMGNvZmZlZSUyMG1ha2VyJTIwbWluaW1hbGlzdCUyMGJsYWNrfGVufDB8fHx8MTc9MDQxOTk3Nnww&ixlib=rb-4.1.0&q=85",
    link: HOME_KITCHEN_LINK,
    description: "Artisanal stove-top espresso coffee pot crafted with heat-resistant matte finish and ergonomic handle.",
  },
  {
    id: "prod-3",
    title: "Invicta Pro Diver Automatic — 44mm Gold & Black",
    category: "Fashion & Accessories",
    price: "₹18,275",
    rating: 3.0,
    reviews: 2,
    badge: "Automatic",
    image: "https://images.unsplash.com/photo-1604727199378-bf5dd08726ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxmYXNoaW9uJTIwYWNjZXNzb3JpZXMlMjBzbWFydHdhdGNoJTIwc3VuZ2xhc3NlcyUyMGxlYXRoZXJ8ZW58MHx8fHwxNzkwNDE5OTYzfDA&ixlib=rb-4.1.0&q=85",
    link: INVICTA_LINK,
    description: "NH35A automatic movement, stainless steel case, black dial with gold accents, 100m water resistance.",
  },
  {
    id: "prod-4",
    title: "Rigohill Doger Olive Green Leather Wallet",
    category: "Fashion & Accessories",
    price: "₹449",
    rating: 4.2,
    reviews: 10821,
    badge: "RFID Protected",
    image: "https://images.unsplash.com/photo-1629139033414-76f3c0eacf84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxmYXNoaW9uJTIwYWNjZXNzb3JpZXMlMjBzbWFydHdhdGNoJTIwc3VuZ2xhc3NlcyUyMGxlYXRoZXJ8ZW58MHx8fHwxNzkwNDE5OTYzfDA&ixlib=rb-4.1.0&q=85",
    link: "https://link.amazon/B02mzr3OW",
    description: "Genuine leather bifold with 7 card slots, ID window, coin pocket, and RFID protection in olive green.",
  },
  {
    id: "prod-5",
    title: "Minimalist Workstation Desk Setup Combo",
    category: "Electronics & Gadgets",
    price: "$420.00",
    rating: 4.9,
    reviews: 670,
    badge: "Hot Product",
    image: "https://images.unsplash.com/photo-1595303526913-c7037797ebe7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwZWxlY3Ryb25pY3MlMjBnYWRnZXRzJTIwdGVjaHxlbnwwfHx8fDE3OTA0MTk5NjN8MA&ixlib=rb-4.1.0&q=85",
    link: FESTIVAL_LINK,
    description: "Ultra-sleek aluminum laptop riser stand, wireless mechanical keyboard, and precision trackpad bundle.",
  },
  {
    id: "prod-6",
    title: "Modernist Architectural Kitchen Counter Stools",
    category: "Home & Kitchen",
    price: "$210.00",
    rating: 4.6,
    reviews: 195,
    badge: "AD Highlight",
    image: "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxob21lJTIwZGVjb3IlMjBraXRjaGVuJTIwYWVzdGhldGljcyUyMG1vZGVybnxlbnwwfHx8fDE3OTA0MTk5NjN8MA&ixlib=rb-4.1.0&q=85",
    link: HOME_KITCHEN_LINK,
    description: "Solid walnut wooden bar stools with ergonomic contouring for contemporary dining island spaces.",
  },
  {
    id: "prod-7",
    title: "Next-Gen Smart Home Command Hub",
    category: "Electronics & Gadgets",
    price: "$129.99",
    rating: 4.8,
    reviews: 764,
    badge: "New Arrival",
    image: "https://images.unsplash.com/photo-1515940175183-6798529cb860?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwZWxlY3Ryb25pY3MlMjBnYWRnZXRzJTIwdGVjaHxlbnwwfHx8fDE3OTA0MTk5NjN8MA&ixlib=rb-4.1.0&q=85",
    link: FESTIVAL_LINK,
    description: "Voice-first smart hub with edge-to-edge display, room-filling audio, and seamless device control.",
  },
  {
    id: "prod-8",
    title: "Scandinavian Ceramic Dinnerware Set",
    category: "Home & Kitchen",
    price: "$89.00",
    rating: 4.7,
    reviews: 428,
    badge: "Curated",
    image: "https://images.unsplash.com/photo-1609347744403-2306e8a9ae27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxob21lJTIwZGVjb3IlMjBraXRjaGVuJTIwYWVzdGhldGljcyUyMG1vZGVybnxlbnwwfHx8fDE3OTA0MTk5NjN8MA&ixlib=rb-4.1.0&q=85",
    link: HOME_KITCHEN_LINK,
    description: "Twelve-piece matte stoneware collection in warm neutrals, kiln-fired for everyday durability.",
  },
  {
    id: "prod-9",
    title: "STEM Magnetic Building Blocks Set",
    category: "Toys & Games",
    price: "$49.99",
    rating: 4.8,
    reviews: 623,
    badge: "Kids' Favorite",
    image: "https://images.unsplash.com/photo-1712771155644-9ce7c22790d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHxfHx3b29kZW4lMjB0b3lzJTIwc3R1ZGlvJTIwZGFyayUyMGJhY2tncm91bmQlMjBTVEVNJTIwYmxvY2tzJTIwcm9ib3QlMjB0b3l8ZW58MHx8fHwxNzkwNDIwOTY4fDA&ixlib=rb-4.1.0&q=85",
    link: TOYS_LINK,
    description: "Sixty-piece magnetic construction kit that turns screen time into hands-on engineering play.",
  },
  {
    id: "prod-10",
    title: "Interactive Learning Robot Toy",
    category: "Toys & Games",
    price: "$89.95",
    rating: 4.7,
    reviews: 411,
    badge: "Trending",
    image: "https://images.unsplash.com/photo-1608875373578-5a0339c66051?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHx3b29kZW4lMjB0b3lzJTIwc3R1ZGlvJTIwZGFyayUyMGJhY2tncm91bmQlMjBTVEVNJTIwYmxvY2tzJTIwcm9ib3QlMjB0b3l8ZW58MHx8fHwxNzkwNDIwOTY4fDA&ixlib=rb-4.1.0&q=85",
    link: TOYS_LINK,
    description: "Voice-responsive robot companion that teaches coding basics through games and storytelling.",
  },
  {
    id: "prod-11",
    title: "Artisan Gourmet Coffee Lover's Gift Box",
    category: "Home & Kitchen",
    price: "$79.00",
    rating: 4.9,
    reviews: 258,
    badge: "Gift Pick",
    image: "https://images.unsplash.com/photo-1761393877623-4412d7060ba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHxfHxnb3VybWV0JTIwY29mZmVlJTIwZ2lmdCUyMGJveCUyMGFydGlzYW5hbCUyMGNvZmZlZSUyMGRhcmslMjBtb29keSUyMGZvb2QlMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3OTA0MjA5Njh8MA&ixlib=rb-4.1.0&q=85",
    link: GOURMET_LINK,
    description: "Small-batch single-origin beans, handcrafted pour-over dripper, and tasting notes in a keepsake box.",
  },
  {
    id: "prod-12",
    title: "OnePlus Pad 2 — 12.1\" 3K, Snapdragon 8 Gen 3",
    category: "Electronics & Gadgets",
    price: "₹31,999",
    rating: 4.4,
    reviews: 835,
    badge: "Featured Deal",
    image: "https://images.unsplash.com/photo-1656275544060-1c0515d192b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHxfHx0YWJsZXQlMjBzdHVkaW8lMjB0ZWNobm9sb2d5JTIwZGFya3xlbnwwfHx8fDE3OTA0MjE1MDR8MA&ixlib=rb-4.1.0&q=85",
    link: ONEPLUS_PAD_LINK,
    description: "12GB RAM, 256GB storage, 144Hz 3K display, six speakers, and a 9610 mAh battery in Nimbus Gray.",
  },
  {
    id: "prod-13",
    title: "Safari Thorium Royale Trolley Bags — Set of 2",
    category: "Fashion & Accessories",
    price: "₹4,599",
    rating: 4.1,
    reviews: 15609,
    badge: "Travel Pick",
    image: "https://images.unsplash.com/photo-1718702662411-11d9672eb179?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx0YW4lMjBwb2x5Y2FyYm9uYXRlJTIwdHJvbGxleSUyMHN1aXRjYXNlJTIwbHVnZ2FnZXxlbnwwfHx8fDE3OTA0MjE2ODd8MA&ixlib=rb-4.1.0&q=85",
    link: SAFARI_LUGGAGE_LINK,
    description: "Unbreakable polycarbonate hard cases with TSA lock, 360° spinner wheels, and organized wet-pouch interior.",
  },
  {
    id: "prod-14",
    title: "boAt Stone 350 Pro Plus Bluetooth Speaker",
    category: "Electronics & Gadgets",
    price: "₹1,599",
    rating: 4.2,
    reviews: 4087,
    badge: "Budget Beast",
    image: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxwb3J0YWJsZSUyMGJsYWNrJTIwYmx1ZXRvb3RoJTIwc3BlYWtlciUyMHN0dWRpbyUyMHByb2R1Y3R8ZW58MHx8fHwxNzkwNDIxNjkwfDA&ixlib=rb-4.1.0&q=85",
    link: BOAT_SPEAKER_LINK,
    description: "16W signature sound, 8-hour playtime, IPX5 splash resistance, and Type-C charging in Carbon Black.",
  },
  {
    id: "prod-15",
    title: "String Swing Wireless Collar Microphone",
    category: "Electronics & Gadgets",
    price: "₹1,799",
    rating: 3.2,
    reviews: 54,
    badge: "Creator's Tool",
    image: "https://images.unsplash.com/photo-1580493783887-8c874c534e93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHx3aXJlbGVzcyUyMGxhdmFsaWVyJTIwbWljcm9waG9uZSUyMHN0dWRpbyUyMHByb2R1Y3QlMjBkYXJrfGVufDB8fHx8MTc5MDQyMjA1MXww&ixlib=rb-4.1.0&q=85",
    link: MIC_LINK,
    description: "Clip-on wireless mic with noise reduction and 360° pickup for YouTube, vlogging, and live streams.",
  },
  {
    id: "prod-16",
    title: "LG 12kg AI DD Front-Load Washing Machine",
    category: "Home & Kitchen",
    price: "₹48,990",
    rating: 4.1,
    reviews: 18724,
    badge: "5-Star Rated",
    image: "https://images.unsplash.com/photo-1778731660255-215c9172e18d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHszfHxtb2Rlcm4lMjBibGFjayUyMHdhc2hpbmclMjBtYWNoaW5lJTIwbWluaW1hbCUyMGxhdW5kcnklMjByb29tfGVufDB8fHx8MTc9MDQyNTE1Mnww&ixlib=rb-4.1.0&q=85",
    link: LG_WM_LINK,
    description: "AI Direct Drive with steam wash, Wi-Fi ThinQ control, and tempered glass door in Onyx Black.",
  },
  {
    id: "prod-17",
    title: "Fashion Dream Girls' Jumpsuit Set — Maroon",
    category: "Fashion & Accessories",
    price: "₹563",
    rating: 4.1,
    reviews: 216,
    badge: "Kids' Style",
    image: "https://images.unsplash.com/photo-1765181118733-7cc5e7d585d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA8Mzl8MHwxfHNlYXJjaHwyfHxraWRzJTIwbWFyb29uJTIwZHJlc3MlMjBmYXNoaW9uJTIwc3R1ZGlvfGVufDB8fHx8MTc5MDQyNTQ2N3ww&ixlib=rb-4.1.0&q=85",
    link: KIDS_JUMPSUIT_LINK,
    description: "Sleeveless cotton-blend ankle-length jumpsuit for girls 7–14 years — festive, party, and everyday wear.",
  },
  {
    id: "prod-18",
    title: "Ghar Soaps De-Tan Face Wash — 100ml",
    category: "Beauty & Personal Care",
    price: "₹249",
    rating: 4.0,
    reviews: 1783,
    badge: "Ayurvedic",
    image: "https://images.unsplash.com/photo-1633793566189-8e9fe6f817fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6OTV8MHwxfHNlYXJjaHwyfHxheXVydmVkaWMlMjBza2luY2FyZSUyMGphciUyMGNvc21ldGljcyUyMGRhcmt8ZW58MHx8fHwxNzkwNDI1NDY3fDA&ixlib=rb-4.1.0&q=85",
    link: BEAUTY_GHAR_LINK,
    description: "Sandalwood, saffron, coconut oil, and goat milk gel face wash for tan reduction and glow — all skin types.",
  },
  {
    id: "prod-19",
    title: "Arayna Cotton Floral Kurta Set with Dupatta",
    category: "Fashion & Accessories",
    price: "₹998",
    rating: 4.1,
    reviews: 142,
    badge: "Ethnic Edit",
    image: "https://images.unsplash.com/photo-1708534246055-d7b149acb731?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjB3b21lbnMlMjBrdXJ0YSUyMHN1aXQlMjBkdXBhdHRhJTIwZWRpdG9yaWFsfGVufDB8fHx8MTc9MDQyNjg5NHww&ixlib=rb-4.1.0&q=85",
    link: KURTA_LINK,
    description: "Pure cotton three-piece ethnic suit with embroidered V-neck, floral print, pants, and dupatta — festive ready.",
  },
  {
    id: "prod-20",
    title: "Rubans Emerald & Zirconia Drop Earrings",
    category: "Fashion & Accessories",
    price: "₹690",
    rating: 4.3,
    reviews: 5000,
    badge: "Jewel Tone",
    image: "https://images.unsplash.com/photo-1732136735241-79e393f66398?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxlbWVyYWxkJTIwZ3JlZW4lMjBnZW1zdG9uZSUyMGVhcnJpbmdzJTIwZGFyayUyMGpld2Vscnl8ZW58MHx8fHwxNzkwNDI2ODk0fDA&ixlib=rb-4.1.0&q=85",
    link: EARRINGS_LINK,
    description: "Rhodium-plated emerald-green drops framed with cubic zirconia — lightweight, tarnish-resistant, wedding-ready.",
  },
  {
    id: "prod-21",
    title: "Shankhraj Rose Gold Crystal Watch & Bracelet Combo",
    category: "Fashion & Accessories",
    price: "₹266",
    rating: 3.4,
    reviews: 8,
    badge: "Gift Set",
    image: "https://images.unsplash.com/photo-1784746724229-dec207876a7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxlbWVyYWxkJTIwZ3JlZW4lMjBnZW1zdG9uZSUyMGVhcnJpbmdzJTIwZGFyayUyMGpld2Vscnl8ZW58MHx8fHwxNzkwNDI2ODk0fDA&ixlib=rb-4.1.0&q=85",
    link: BRACELET_LINK,
    description: "Diamond-look crystal bracelet and rose-gold watch gift set — skin-friendly, wedding and anniversary ready.",
  },
  {
    id: "prod-22",
    title: "Hawkins 5L Triply Contura Pressure Cooker",
    category: "Home & Kitchen",
    price: "₹3,939",
    rating: 4.4,
    reviews: 744,
    badge: "Kitchen Classic",
    image: "https://images.unsplash.com/photo-1580929753603-10519c6e480a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHxfHxzdGFpbmxlc3MlMjBzdGVlbCUyMHByZXNzdXJlJTIwY29va2VyJTIwa2l0Y2hlbnxlbnwwfHx8fDE3OTA0Mjc0Mzl8MA&ixlib=rb-4.1.0&q=85",
    link: COOKER_LINK,
    description: "Triply stainless steel body, induction and gas compatible, Contura shape for easy stirring — built to last decades.",
  },
  {
    id: "prod-23",
    title: "NINTARABABY Organic Muslin Swaddles — Pack of 3",
    category: "Baby Care",
    price: "₹1,199",
    rating: 4.6,
    reviews: 60,
    badge: "Newborn Essential",
    image: "https://images.unsplash.com/photo-1663247131274-ecbf38ec087c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxiYWJ5JTIwYmxhbmtldCUyMGZvbGRlZCUyMG5ldXRyYWx8ZW58MHx8fHwxNzkwNDI5NzIxfDA&ixlib=rb-4.1.0&q=85",
    link: SWADDLE_LINK,
    description: "100% organic cotton muslin, 100×100 cm, hypoallergenic and breathable — swaddle, stroller blanket, or tummy-time mat.",
  },
  {
    id: "prod-24",
    title: "Gold-Plated Temple Jewellery Set — Peacock Pendant & Jhumkas",
    category: "Fashion & Accessories",
    price: "₹449",
    rating: 4.5,
    reviews: 5,
    badge: "Bridal Pick",
    image: "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxnb2xkJTIwbmVja2xhY2UlMjBqZXdlbHJ5JTIwZGFya3xlbnwwfHx8fDE3OTA0MzA2NDN8MA&ixlib=rb-4.1.0&q=85",
    link: TEMPLE_LINK,
    description: "Antique-finish temple necklace with ruby teardrop pendant, peacock engraving, and matching jhumka earrings.",
  },
  {
    id: "prod-25",
    title: "Atasi Rose Gold Necklace Set with Maang Tikka",
    category: "Fashion & Accessories",
    price: "₹359",
    rating: 4.0,
    reviews: 536,
    badge: "Wedding Edit",
    image: "https://images.unsplash.com/photo-1720528347553-5a251993ee00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxyb3NlJTIwZ29sZCUyMG5lY2tsYWNlJTIwamV3ZWxyeXxlbnwwfHx8fDE3OTA0MzA2NDN8MA&ixlib=rb-4.1.0&q=85",
    link: NECKLACE_LINK,
    description: "Rose-gold plated crystal necklace, earrings, and maang tikka — skin-friendly bridal set for weddings and festivals.",
  },
  {
    id: "prod-26",
    title: "Blue Nectar Saffron & Sandalwood Face Cream — 50g",
    category: "Beauty & Personal Care",
    price: "₹1,010",
    rating: 4.1,
    reviews: 1492,
    badge: "Men's Grooming",
    image: "https://images.unsplash.com/photo-1783905326791-c1fb6b8bc113?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaH3fHxza2luY2FyZSUyMGZhY2UlMjBjcmVhbSUyMGFtYmVyJTIwamFyJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc5MDQyNTQ3MHww&ixlib=rb-4.1.0&q=85",
    link: "https://link.amazon/B0dSU63m8",
    description: "Ayurvedic anti-aging day & night cream with 14 herbs — saffron and sandalwood for bright, firm skin.",
  },
  {
    id: "prod-27",
    title: "Lifelong LLGM109 Percussion Massage Gun",
    category: "Beauty & Personal Care",
    price: "₹699",
    rating: 4.3,
    reviews: 2814,
    badge: "Recovery Tool",
    image: "https://images.unsplash.com/photo-1746278925416-9d6c71f55c2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw3fHxtYXNzYWdlJTIwZ3VuJTIwYmxhY2slMjBoYW5kaGVsZHxlbnwwfHx8fDE3OTA0MjU1MjR8MA&ixlib=rb-4.1.0&q=85",
    link: "https://link.amazon/B07gZVzF5",
    description: "6 speeds and 8 massage heads, cordless and quiet — deep-tissue relief for neck, shoulders, back, and legs.",
  },
  {
    id: "prod-28",
    title: "iQOO Z11 Lite 5G — 4GB/128GB, Solar Flame",
    category: "Electronics & Gadgets",
    price: "₹19,497",
    rating: 3.7,
    reviews: 258,
    badge: "5G Budget Pick",
    image: "https://images.unsplash.com/photo-1773414422103-7aa2623de1fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw3fHxzbWFydHBob25lJTIwb3JhbmdlJTIwZ3JhZGllbnQlMjBiYWNrJTIwcHJvZHVjdCUyMHNob3QlMjBkYXJrJTIwc3R1ZGlvfGVufDB8fHx8MTc5MjMyNTUyMHww&ixlib=rb-4.1.0&q=85",
    link: "https://link.amazon/B0huMyoms",
    description: "6500mAh battery, Dimensity 6300, 50MP camera, 6.74-inch display, and 44W fast charging.",
  },
  {
    id: "prod-29",
    title: "TAGAS Girls' 3-Piece Camisole, Shirt & Pants Set",
    category: "Fashion & Accessories",
    price: "₹429",
    rating: 3.9,
    reviews: 85,
    badge: "Casual Set",
    image: "https://images.unsplash.com/photo-1708523842501-800cd1c7505e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHx3b21lbiUyMGNhc3VhbCUyMG91dGZpdCUyMHNldCUyMGZhc2hpb24lMjBzdHVkaW98ZW58MHx8fHwxNzkyMzI1NTI0fDA&ixlib=rb-4.1.0&q=85",
    link: "https://link.amazon/B0dyHfDGh",
    description: "Solid camisole top, long-sleeve shirt, and straight pants in soft polyester — an easy everyday coord.",
  },
  {
    id: "prod-30",
    title: "Zaveri Pearls Mint Green Enamel Jhumki Earrings",
    category: "Fashion & Accessories",
    price: "₹259",
    rating: 3.8,
    reviews: 262,
    badge: "Festive Pick",
    image: "https://images.unsplash.com/photo-1646031348680-0756f9eb8b9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxlbWVyYWxkJTIwZ3JlZW4lMjBnZW1zdG9uZSUyMGVhcnJpbmdzJTIwZGFyayUyMGpld2Vscnl8ZW58MHx8fHwxNzkwNDI2ODk0fDA&ixlib=rb-4.1.0&q=85",
    link: "https://link.amazon/B05VSs8qf",
    description: "22K gold-plated ethnic jhumkis with mint-green enamel, stones, and beads — 4.2 cm festive drop.",
  },
];
